import React from 'react';
import { Show, SimpleShowLayout, TextField, FunctionField, RichTextField, ListButton, CardActions } from 'react-admin';
import BooleanIntegerField from '../../fields/BooleanIntegerField';

const difficultyMapping = {
  1: 'Easy',
  2: 'Medium',
  3: 'Hard',
};

const cardActionStyle = {
  zIndex: 2,
  display: 'inline-block',
  float: 'right',
};

const ExerciseShowActions = ({ basePath, data }) => (
  <CardActions style={cardActionStyle}>
    <ListButton basePath={basePath} />
  </CardActions>
);

const ExerciseShow = props => {
  return (
    <Show {...props} actions={<ExerciseShowActions />}>
      <SimpleShowLayout>
        <TextField source="name" />
        <FunctionField label="Difficulty" render={record => difficultyMapping[record.difficulty]} />
        <BooleanIntegerField source="public" />
        <FunctionField
          label="Image"
          render={record => {
            const source = record.canvas ? record.canvas_image_urls.editor : record.image_urls.editor;
            return (
              <div>
                <img src={source} style={{ margin: '0.5rem', maxHeight: '10rem' }} alt="" />
              </div>
            );
          }}
        />
        <RichTextField source="description" />
        <RichTextField source="materials" />
        <FunctionField
          label="Primary Objective"
          render={record => (record.primary_objective ? record.primary_objective.name : '')}
        />
        <FunctionField
          label="Secondary Objective"
          render={record => (record.secondary_objective ? record.secondary_objective.name : '')}
        />
        <FunctionField
          label="Tags"
          render={record => (record.tags ? record.tags.map(tag => tag.name).join(', ') : '')}
        />
        <TextField source="players" />
        <TextField source="exercise_minutes" />
        <TextField source="sets" />
        <TextField source="recovery_minutes" />
        <TextField source="recoveries" />
      </SimpleShowLayout>
    </Show>
  );
};

export default ExerciseShow;



// WEBPACK FOOTER //
// ./src/resources/exercises/ExerciseShow.jsx